import { xhr } from '@core/tools/xhr';

const ssoCheckoutDataUrl = (lang = 'pl_PL'): string => `/webapi/front/${lang}/user/sso/checkout-data`;

export const getSSOCheckoutData = async (lang: string): Promise<unknown> => {
    try {
        const response = await xhr<any>({
            url: ssoCheckoutDataUrl(lang),
            method: 'get'
        });

        if (response && response.status === 200) {
            return response.data;
        }
    } catch (err) {
        console.error(err);
        return null;
    }
};

const checkSSOUserUrl = (lang = 'pl_PL'): string => `/webapi/front/${lang}/user/sso/check`;

export const checkSSOUser = async (email: string, lang: string): Promise<unknown> => {
    try {
        const response = await xhr<any>({
            url: checkSSOUserUrl(lang),
            method: 'post',
            data: {
                email
            }
        });

        if (response && response.status === 200) {
            return Boolean(response.data && response.data.exists);
        }
    } catch (err) {
        console.error(err);
        return null;
    }
};
